// src/services/AdminGestionService.js
// Toutes les requêtes de l'espace admin (fetch + token admin).

import { base_url } from "../utils/constante";

function getToken() {
    return localStorage.getItem("token_admin") || sessionStorage.getItem("token_admin");
}

function headers() {
    return {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
    };
}

/** Appel générique : renvoie le JSON, lève une erreur avec le message du serveur */
async function appel(chemin, { method = "GET", body } = {}) {
    const res = await fetch(`${base_url}${chemin}`, {
        method,
        headers: headers(),
        body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const e = new Error(data.message || "Erreur serveur");
        e.status = res.status;
        throw e;
    }
    return data;
}

/** Transforme { q:"x", page:2, role:"" } en "?q=x&page=2" (ignore les vides) */
function qs(params = {}) {
    const p = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== "") p.append(k, v);
    });
    const s = p.toString();
    return s ? `?${s}` : "";
}

// ── Tableau de bord ─────────────────────────────────────
export const getStatsAdmin = () => appel("admin/stats");

// ── Utilisateurs ────────────────────────────────────────
export const getUtilisateurs = (params) => appel(`admin/utilisateurs${qs(params)}`);
export const changerRole = (id, role) => appel(`admin/utilisateurs/${id}/role`, { method: "PATCH", body: { role } });
export const basculerBlocage = (id) => appel(`admin/utilisateurs/${id}/bloquer`, { method: "PATCH" });

// ── Créateurs ───────────────────────────────────────────
export const getCreateurs = (params) => appel(`admin/createurs${qs(params)}`);

// ── Événements ──────────────────────────────────────────
export const getEvenementsAdmin = (params) => appel(`admin/evenements${qs(params)}`);
export const basculerEvenement = (id) => appel(`admin/evenements/${id}/actif`, { method: "PATCH" });
export const supprimerEvenement = (id) => appel(`admin/evenements/${id}`, { method: "DELETE" });
export const reporterEvenement = (id, date) => appel(`admin/evenements/${id}/reporter`, { method: "PATCH", body: { date } });
export const annulerEvenementAdmin = (id, commentaire) =>
    appel(`createur/evenement/${id}/annuler`, { method: "POST", body: { motif: "evenement_annule", commentaire } });

// ── Réservations ────────────────────────────────────────
export const getReservationsAdmin = (params) => appel(`admin/reservations${qs(params)}`);

// ── Finances / versements ───────────────────────────────
export const getFinances = () => appel("admin/finances");
export const synchroniserFinances = () => appel("admin/finances/synchroniser", { method: "POST" });
export const getVersements = (params) => appel(`admin/versements${qs(params)}`);

// ── Demandes des organisateurs ──────────────────────────
export const getDemandes = (params) => appel(`admin/demandes${qs(params)}`);
export const traiterDemande = (id, statut) =>
    appel(`admin/demandes-evenement/${id}/traiter`, { method: "POST", body: { statut } });

// ── Annulations (suivi) ─────────────────────────────────
export const getSuiviAnnulations = () => appel("admin/annulations");